export const CONSENT_ACTION_TYPES = {
  SET_CONSENTS: 'SET_CONSENTS',
  SET_OWNER_CONSENTS: 'SET_OWNER_CONSENTS',
  SET_SHOW_CREATE_CONSENT_MODAL: 'SET_SHOW_CREATE_CONSENT_MODAL',
  SET_SHOW_RENEW_CONSENT_MODAL: 'SET_SHOW_RENEW_CONSENT_MODAL',
};
